export const buildAADGroupName = (values: any) => {
  if (values.scope === 'SUB') {
    return `AAD_${values.vertical}_${values.scope}_${values.role}_${values.env}`.toUpperCase();
  }
  return `AAD_${values.vertical}_${values.scope}_${values.appName ? values.appName : ''}_${values.role}_${
    values.env
  }`.toUpperCase();
};
